import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-circular-progress-bar',
  templateUrl: './circular-progress-bar.component.html',
  styleUrls: ['./circular-progress-bar.component.scss']
})
export class CircularProgressBarComponent implements OnChanges {
  @Input() percentage: number;

  ngOnChanges(changes: SimpleChanges) {
    this.changeGraphic();
  }

  changeGraphic() {
    let self = this;
    $(".progress").each(function () {
      var left = $(this).find('.progress-left .progress-bar');
      var right = $(this).find('.progress-right .progress-bar');

      if (self.percentage > 0) {
        if (self.percentage <= 50) {
          right.css('transform', 'rotate(' + self.percentageToDegrees(self.percentage) + 'deg)');
          left.css('transform', 'rotate(0deg)');
        } else {
          right.css('transform', 'rotate(180deg)');
          left.css('transform', 'rotate(' + self.percentageToDegrees(self.percentage - 50) + 'deg)');
        }
      }
    });
  }

  private percentageToDegrees(percentage) {
    return percentage / 100 * 360;
  }
}
